import { render, staticRenderFns } from "./DayTimeTableDetail.vue?vue&type=template&id=20913fb2"
import script from "./DayTimeTableDetail.vue?vue&type=script&lang=js"
export * from "./DayTimeTableDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports